import { ArrowBackIcon } from "@chakra-ui/icons";
import {
  Box, Container,
  Flex,
  Heading,
  IconButton,
  Spinner,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";

import { getTest } from "../../shared/Api";
import CCIGraph from "../../shared/components/CCIGraph";
import { Paths } from "../../shared/model/Constants";
import { adminKeys } from "../../shared/QueryKeys";
import { extractData, isAdaptive } from "../../shared/Utils";

const TestDetail = () => {
  const params = useParams<{ id: string }>();
  const id = params.id || "";
  const navigate = useNavigate();
  const testQuery = useQuery(adminKeys.testsById(id), () =>
    getTest(id).then(extractData)
  );

  function handleBackClick() {
    navigate(Paths.ADMIN);
  }

  if (!testQuery.data) {
    return <Spinner />;
  } else {
    return (
      <Container maxW="container.lg" marginX="auto">
        <Flex>
          <IconButton
            aria-label="Volver"
            icon={<ArrowBackIcon />}
            onClick={handleBackClick}
            marginRight="2"
          />
          <Heading>{testQuery.data.name}</Heading>
        </Flex>

        {isAdaptive(testQuery.data.testType) && (
          <>
            <Text>CCI de cada pregunta</Text>
            <CCIGraph
              dataset={testQuery.data.dataset}
              questions={testQuery.data.questions}
            />
          </>
        )}

        <Text>Preguntas</Text>

        {testQuery.data.questions.map((question) => (
          <Box
            key={question.id}
            marginTop="2"
            marginBottom="2"
            padding="2"
            borderWidth="1px"
            borderRadius="lg"
            borderColor="gray.300"
            borderStyle="solid"
          >
            <Text>Id: {question.id}</Text>
            <Text>{question.statement}</Text>
            <Text>Parámetros</Text>
            <Text>a: {question.a}</Text>
            <Text>b: {question.b}</Text>
            <Text>c: {question.c}</Text>
          </Box>
        ))}
      </Container>
    );
  }
};

export default TestDetail;
